//import PubSub from '/lib/pubsub.js'
import PubSub from "pubsub-js";
import moment from "moment";
import { storeInstance } from "../store/index.js";
import getProductTreeId from "../utils/getProductTreeId.js";

export const log = function (msg) {
  console.log(msg);
};

export const updatePageLocation = function (newurl) {
  history.pushState(null, null, newurl);
};

export const notifyUser = function (type, message, duration) {
  PubSub.publish("notifyUser", { type, message, duration });
};

export const getPrevious = function (currentTopicNode) {
  var previous = null;
  if (currentTopicNode.parent) {
    var localArray = currentTopicNode.parent.nodes;
    var ubound = localArray.length - 1;
    var index = getIndexInArray(localArray, currentTopicNode.title);
    if (index > 0) {
      if (currentTopicNode.parent.nodes[index - 1].nodes) {
        previous =
          currentTopicNode.parent.nodes[index - 1].nodes[
            currentTopicNode.parent.nodes[index - 1].nodes.length - 1
          ];
      } else {
        previous = currentTopicNode.parent.nodes[index - 1];
      }
    } else {
      if (index == 0) {
        previous = currentTopicNode.parent;
      } else {
      }
    }
  } else {
    //is root no previous
  }
  return previous;
};

export const recurseToHREF = function (node) {
  if (node) {
    if (node.href) {
      //if(node.href.substring(0, 4).toLowerCase()!='href'){
      return node;
      //}
    }
  }

  if (node.nodes) {
    return recurseToHREF(node.nodes[0]);
  } else {
    if (node.parent) {
      var localArray = node.parent.nodes;
      var ubound = localArray.length - 1;
      var index = getIndexInArray(localArray, node.title);
      if (index < ubound) {
        return _recurseToHREF(node.parent.nodes[index + 1]);
      } else {
        if (node.parent.parent) {
          localArray = node.parent.parent.nodes;
          ubound = localArray.length - 1;

          index = getIndexInArray(localArray, node.parent.title);

          if (index <= ubound) {
            return recurseToHREF(localArray[index + 1]);
          } else {
            next = null; //end of tree?
          }
        }
      }
    }
  }
};

export const recurseToParentHREF = function (node, title) {
  var localArray = node.nodes;
  var ubound = localArray.length - 1;
  var index = getIndexInArray(localArray, title);
  if (index < ubound) {
    return node.nodes[index + 1];
  } else {
    if (node.parent) {
      return recurseToParentHREF(node.parent, node.title);
    } else {
      //root node
    }
  }
};

export const getNext = function (currentTopicNode) {
  var next = null;
  if (currentTopicNode.nodes) {
    next = recurseToHREF(currentTopicNode.nodes[0]);
  } else {
    if (currentTopicNode.parent) {
      next = recurseToParentHREF(
        currentTopicNode.parent,
        currentTopicNode.title
      );
    }
  }
  return next;
};

export const getIndexInArray = function (localArray, targetTitle) {
  var index = localArray.findIndex(function (item, i) {
    return item.title == targetTitle;
  });
  return index;
};

export const setParents = function (node, parent) {
  node.open = false; //handy place to set this default status
  if (parent) {
    node.parent = parent;
  }
  if (node.nodes) {
    for (var i = 0; i < node.nodes.length; i++) {
      setParents(node.nodes[i], node);
    }
  } else {
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        setParents(node.children[i], node);
      }
    }
  }
};

export const setOpened = function (node) {
  node.open = true;
  if (node.parent) {
    setOpened(node.parent);
  }
};

export const getSupportedLang = function (langCode) {
  if (state[langCode]) {
    state[langCode];
  } else {
    state[state.default_lang_code];
  }
};

export const getAvailableLanguages = async () => {
  const languages = await getLanguages();
  const langcodes = languages.map((lang) => lang.langCode);
  // const langcodesSet = new Set(langcodes);
  // const kbStoreKeySet = new Set(Object.keys(Store.state));
  // const avaliableLanguagesSet = myIntersection(langcodesSet, kbStoreKeySet);
  return langcodes;
};

export const getLanguages = async () => {
  try {
    const response = await fetch("/kb/jrest/getLanguages");
    const languages = await response.json();
    if (!response.ok) {
      httpError(response, Store);
      throw new Error(response.statusText); //to bail out of promise chain
    }
    return languages;
  } catch (e) {
    console.log(e);
  } finally {
    PubSub.publish("requestin", null);
  }
};

export function isDate(value) {
  return value instanceof Date && !isNaN(+value);
}

export function formatDate(inVal) {
  return moment(inVal).format("LLLL");
}

export function controlValuesToLstValues(controlValues) {
  let keys = Object.keys(controlValues).filter(
    (key) => controlValues[key].length > 0
  );
  return {
    PanelControlValues: {
      lstValues: keys.map((controlId) => ({
        controlDefId: controlId,
        lstValues: controlValues[controlId],
      })),
    },
  };
}

export function setProductTree(externalId) {
  const productTreeId = getProductTreeId();
  storeInstance.dispatch("setState", {
    property: "control_values",
    value: {
      [productTreeId]: [
        {
          id: externalId,
          value: getValueFromTreeControlData(externalId),
        },
      ],
    },
  });
}

export function getValueFromListControlData(propertyValueId, controlId) {
  const listControl = storeInstance.state.control_def_data_array.find(
    (control) => control.controlDefId == controlId
  );
  return listControl.propertyData.propertyValues.find(
    (propertyValue) => propertyValue.id == propertyValueId
  ).value;
}

/** Used to get a value from tree */
export function getValueFromTreeControlData(id) {
  const productTreeId = getProductTreeId(
    storeInstance.state.panel_control_defs
  );
  const tree = storeInstance.state.control_def_data_array.find(
    (control) => control.controlDefId == productTreeId
  );
  return getValueFromTree(tree.propertyData.rootNode, id);
}

const getValueFromTree = (node, id) => {
  if (node.propertyValue.id === id) {
    return node.propertyValue.value;
  }

  for (let child of node.children) {
    let value = getValueFromTree(child, id);
    if (value) return value;
  }

  return undefined;
};

/** Get urlsearchTerm */

export function getSearchResultsURL(isPartitionSearch) {
  let urlParams = new URLSearchParams({
    langCode: storeInstance.state.langCode,
    panelName: "KbPanel",
  });
  urlParams = processSearchTerm(urlParams);
  urlParams = processPanelData(urlParams);
  urlParams = processPages(urlParams, isPartitionSearch);
  return urlParams.toString();
}

const processSearchTerm = (params) => {
  if (storeInstance.state.search_term?.searchterm) {
    params.set("searchText", storeInstance.state.search_term.searchterm);
  }
  return params;
};

const processPanelData = (params) => {
  let panelData = controlValuesToLstValues(storeInstance.state.control_values);
  params.set("panelControlDefsJSon", JSON.stringify(panelData));
  return params;
};

const processPages = (params, isPartitionSearch) => {
  let totRows;
  let startRow;
  let resultsPerPage = storeInstance.state.max_results;
  let partitionSize = storeInstance.state.partition_size;
  let currentPage = storeInstance.state.current_results_page;
  if (isPartitionSearch) {
    totRows = resultsPerPage * partitionSize;
    startRow = 1;
  } else {
    totRows = resultsPerPage;
    startRow = (currentPage - 1) * resultsPerPage + 1;
  }
  params.set("totRows", totRows + 1);
  params.set("startRow", startRow);
  return params;
};

/**
 * Safely access config variable
 * @returns {any}
 */
export const getConfigVariable = (variableName) => {
  try {
    return window[variableName];
  } catch (e) {
    console.log(e);
  }
};
